// extracted by mini-css-extract-plugin
module.exports = {"items":"Items-module--items--KP5c9","item":"Items-module--item--1yc84","itemTitle":"Items-module--itemTitle--mNg9z"};